<nz-card class="card-standalone ant-card ant-card-bordered">
  <div class="logo-wrapper cursor-pointer" routerLink="/">
    <img
      src="/assets/images/logos/oxio-logo.png"
      alt="OXIO logo"
      class="w-100"
    />
  </div>

  <h1 nz-typography class="text-center" [innerHTML]="title"></h1>

  <ng-content></ng-content>
</nz-card>
